import Hooks from 'js/hooks';
import { global_hooks } from 'src/globals';
import { get_el, set_defaults } from 'js/utils';

import './loading/loading';
import './render_items';
import './filters/filters';
import './search';
import './load_all';
import './load_more/load_more';
import './listing.scss';

export default function init_listing(container, args = {}) {
	const listing = {
		container: get_el(container),
		hooks: new Hooks(),
		items: [],
		args: set_defaults(
			{
				transition_duration: 300,
				load_more: true,
			},
			args,
		),
	};

	init_items(listing);

	// global_hooks.do('listing/init/before', listing);

	global_hooks.do('listing/init', listing);

	return listing;
}

function init_items(listing) {
	let item_selector = listing.args.item_selector ?? '.item';

	const add_item = (item) => {
		listing.items.push(item);
		listing.hooks.do('item/init', item);
	};

	listing.container.querySelectorAll(item_selector).forEach((el) => {
		const id = parseInt(el.dataset.id);

		const item = {
			data: listing.args.items_data.find((i) => i.id === id),
			el,
		};

		add_item(item);
	});

	listing.hooks.on('item/add', add_item);
}
